export function isPositiveMeasurement(value) {
  return (
    /^\d+(\.\d+)?$/.test(String(value).trim()) &&
    Number.isFinite(Number(value)) &&
    Number(value) > 0
  );
}

// Use the last edited field, never its rounded display counterpart.
export function branchDiameter(branch) {
  const value = branch[branch.source];
  if (!isPositiveMeasurement(value)) return NaN;
  return branch.source === "perimeter"
    ? Number(value) / Math.PI
    : Number(value);
}

export function convertBranches(branches) {
  if (branches.length < 2) throw new Error("請至少輸入兩個分枝。");
  const diameters = branches.map(branchDiameter);
  if (diameters.some(value => !Number.isFinite(value) || value <= 0)) {
    throw new Error("請為每個分枝輸入大於 0 的直徑或周長。");
  }
  const diameter = Math.hypot(...diameters).toFixed(1);
  const perimeter = (Number(diameter) * Math.PI).toFixed(1);
  if (!Number.isFinite(Number(perimeter)) || Number(diameter) <= 0) {
    throw new Error("換算結果超出可顯示範圍，請檢查輸入數值。");
  }
  return { diameter, perimeter };
}
